import { render } from "./RestoreAttachBackupVolume.vue?vue&type=template&id=7f3717f3&scoped=true"
import script from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"
export * from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"

import "./RestoreAttachBackupVolume.vue?vue&type=style&index=0&id=7f3717f3&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3717f3"]])

export default __exports__